<span class="tooltip" [ngClass]="['tooltip--'+position, 'tooltip--'+theme]" [class.tooltip--visible]="visible"
    [style.left]="left + 'px'" [style.top]="top + 'px'">
    {{tooltip}}
</span>